// Module Import
//---------------------------------
import React from 'react'
import styled from 'styled-components'
import TypographyAtom from '../../atoms/typography/typography'
import { brandDarkGrey, brandOrange } from '../../../assets/consts/color'

// Component Import
//---------------------------------

// Styled Component Declarations
//---------------------------------
const HeaderWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin: 0 0 24px 0;
    padding: 0 0 0 24px;
    position: relative;

    &.reverse {
        flex-direction: column-reverse;
    }

    &:before {
        background-color: ${brandOrange};
        content: '';
        height: 100%;
        left: 0;
        position: absolute;
        width: 4px;
    }

    &.gray-background {
        background: rgba(128, 128, 128, 0.5);
        padding-right: 10px;
    }

    &.hide-if-mobile {
        @media only screen and (max-width: 767px) {
            display: none;
        }
    }

    h2 {
        font-weight: 700;
        margin: 0;
        color: ${brandDarkGrey};
    }

    h3 {
        margin: 0;
        color: ${brandDarkGrey};
    }

    @media only screen and (min-width: 48em) {
        margin: 0 0 48px 0;
    }

    &.author-title {
        h2 {
            font-weight: 500;
        }

        margin-bottom: 16px;

        h3 {
            font-size: 18px;

            @media only screen and (min-width: 48em) {
                font-size: 20px;
            }
            @media only screen and (min-width: 64em) {
                font-size: 23px;
            }
        }

        @media only screen and (min-width: 64em) {
            margin-bottom: 40px;
        }
    }
`

// Component Export
//---------------------------------
export default function TextHeader({
  title,
  subtitle,
  articleTitle,
  authorTitle,
  reverse,
  addGrayBackground = false,
}) {
  return (
    <HeaderWrapper
      className={`${authorTitle ? 'author-title' : ''}${reverse ? ' reverse' : ''}${addGrayBackground ? 'gray-background' : ''}`}
    >
      <TypographyAtom type={`${articleTitle ? 'H1' : 'H2'}`} copy={title} weight="Bold" />
      {subtitle && <TypographyAtom type="H3" copy={subtitle} weight="Thin" />}
    </HeaderWrapper>
  )
}

TextHeader.propTypes = {}
